module.exports = __webpack_public_path__ + "components/country-flag/static/me-c1656cae0b648fcaa2ca9b0764c54d79.svg";